import React from "react";
import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";

/**
 * Per-page SEO tags. Renders <title>, <meta description>, canonical, Open
 * Graph and Twitter tags via react-helmet-async. Values are set client-side —
 * a real SSR/pre-render pass is planned separately (react-snap at build time).
 */
export default function Seo({
  title,
  description = "Reserve su cita médica en línea con médicos verificados de Ecuador. Recordatorios, agenda 24/7, sin llamadas.",
  image = "https://www.agendik.io/og-cover.jpg",
  noindex = false,
  canonicalPath, // optional override
}) {
  const loc = useLocation();
  const base = "https://www.agendik.io";
  const path = canonicalPath || (loc.pathname + (loc.search || ""));
  const canonical = base + (path === "/" ? "" : path);
  const fullTitle = title ? `${title} | Agendik` : "Agendik · Citas médicas en línea en Ecuador";
  return (
    <Helmet prioritizeSeoTags>
      <title>{fullTitle}</title>
      <meta name="description" content={description}/>
      <link rel="canonical" href={canonical}/>
      {noindex && <meta name="robots" content="noindex, nofollow"/>}
      <meta property="og:title" content={fullTitle}/>
      <meta property="og:description" content={description}/>
      <meta property="og:type" content="website"/>
      <meta property="og:url" content={canonical}/>
      <meta property="og:image" content={image}/>
      <meta property="og:site_name" content="Agendik"/>
      <meta name="twitter:card" content="summary_large_image"/>
      <meta name="twitter:title" content={fullTitle}/>
      <meta name="twitter:description" content={description}/>
      <meta name="twitter:image" content={image}/>
    </Helmet>
  );
}
